/** @jsxRuntime classic */
/** @jsx jsx */
import React, { useState, useRef } from 'react'
import { NavLink, useNavigate, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { setHeaderName, setTotalCount } from '../../redux/slices/TaskSlice'
import { useEffect } from 'react'
import { taskProjectPosition, totalTaskCount } from '../action/common'
import moment from 'moment'
import { jsx } from "@emotion/core";
import { CheckIcon, InboxIcon, OverDueIcon, NoDateIcon, Trash, UpcomingTasksIcon, FolderIcon, EditIcon2, FolderPlusIcon } from '../LandingHeader/Feedback/icons/Icons'
import { fetchProjectList } from '../action/tasks'
import { setAllProjectsList, setProjectsListWithTasksCount } from '../../redux/slices/ProjectSlice'
import DeleteProjectModal from '../../pages/Settings/Modal/DeleteProjectModal'
import RenameProjectModal from '../../pages/Settings/Modal/RenameProjectModal'
import TaskSourceIcon from '../../pages/Tasks/TaskSourceIcon'
import ActionsDropdown from '../common/ActionsDropdown'
import { sortableContainer, sortableElement, SortableHandle } from 'react-sortable-hoc';
import DragIcon from '../../pages/Tasks/DragIcon'
import { arrayMoveImmutable } from 'array-move'
import TasksStatusWidget from '../../pages/Tasks/TasksStatusWidget'

const DragHandle = SortableHandle(() => <span className="dragdrop-option"><DragIcon /></span>);

function SiteNav(props) {
    const dispatch = useDispatch()
    const [activeHeaderLink, setSelectedActiveHeaderLink] = useState('Upcoming')
    const currentTimes = moment().startOf('date')
    const [currentTime, setCurrentTime] = useState(new Date(currentTimes));
    const theme = useSelector(state => state.theme.theme)
    const totalCount = useSelector(state => state.task.totalCount)
    const projectsListWithTasksCount = useSelector(state => state.project.projectsListWithTasksCount)
    const [showDeleteProjectModal, setShowDeleteProjectModal] = useState(null)
    const [showEditProjectModal, setShowEditProjectModal] = useState(null)
    const [newProject, setNewProject] = useState(false)
    const location = useLocation();
    const navigate = useNavigate();

  function setActiveHeaderLink(header) {
    setSelectedActiveHeaderLink(header)
    dispatch(setHeaderName(header))
  }

  const fetchTotalCount = async () => {
    try {
      let response = await totalTaskCount({ "date": currentTime.toISOString() })
      dispatch(setTotalCount(response?.data?.responseData))
    } catch ({ response }) {}
  }

  useEffect(() => {
    fetchTotalCount();
    fetchProjectListWithTasksCount();
  }, [])

  const openDeleteProjectModal = (e, project) => {
    e.preventDefault()
    e.stopPropagation()
    setShowDeleteProjectModal(project)
  }

  const openEditProjectModal = (e, project) => {
    e.preventDefault()
    e.stopPropagation()
    setNewProject(false);
    setShowEditProjectModal(project)
  }

  const hideProjectModal = (fetchProjectList = false, deletedId = null, renameId = null, renameTitle = null, renameSource = null) => {
    setShowDeleteProjectModal(null)
    setShowEditProjectModal(null)
    setNewProject(false);

    const id = (location.pathname?.split('/')?.[4] ?? '').split('_')[0];

    if(deletedId == id){
        navigate(`/tasks/projects/untitled/-1`)
    }
    if(renameId == id){
        navigate(`/tasks/projects/${renameTitle}/${renameId}${renameSource ? `_${renameSource}` : ''}`)
    }
    if(fetchProjectList){
      fetchProjectListWithTasksCount();
    }
  }

  const fetchProjectListWithTasksCount = () => {
    fetchProjectList({includeTasksCount: true, ordering: '1'}).then((res) => {
      const projects = res?.data?.responseData?.data ? res?.data?.responseData?.data?.map(option => ({value: option.title, label: option.title})) : [];
      dispatch(setProjectsListWithTasksCount(res?.data?.responseData?.data ?? []))
      dispatch(setAllProjectsList(projects))
    })
  }

  const createNewProject = (e) => {
    e.preventDefault()
    e.stopPropagation()
    
    setNewProject(true);
  }

  const SortableItem = sortableElement(({project}) => {
    const title = project.title//.charAt(0).toUpperCase() + project.title.slice(1);
    const renameActive = showEditProjectModal?.project_id == project.project_id;

    return (
        <li className="li-menus border rounded-15 project-list-item" onClick={(e) => {
            e.preventDefault()    
        }} css={{
            '&:hover': {
                position: 'relative',
                '.action-btn-wrapper': {
                    display: 'flex !important'
                },
                '.dragdrop-option': {
                    opacity: '1 !important',
                    left: '-4px',
                    top: '11px'
                }
            }
        }}>
            <>
                <NavLink to={`/tasks/projects/${encodeURIComponent(project.title)}/${encodeURIComponent(project?.description ?? ' ')}/${project.project_id}${project.projectSource ? `_${project.projectSource}` : ''}`}
                className={`!opacity-100 !items-start !justify-start gap-[10px] flex-col relative ${ renameActive ? 'active' : ''}`}
                onClick={() => { setActiveHeaderLink(`Project - ${title}`) }}
                end
                >
                    <div className='flex items-center justify-start gap-[10px] w-full flex-wrap'>
                        <DragHandle />
                        <FolderIcon width={18} height={18} color={activeHeaderLink == `Project - ${title}` ? `var(--accent-color)` : "black"} fill={activeHeaderLink == `Project - ${title}` ? `var(--accent-color)` : "none"} />
                        {
                            renameActive
                            ?
                            <RenameProjectModal project={showEditProjectModal} onHide={hideProjectModal} />
                            :
                            <>
                                {title}
                                <TaskSourceIcon task={{id: project.project_id, taskSource: project.projectSource}} colorPicker={`var(--accent-color)`} />
                                {/* <span className="flex-1 self-stretch"></span>
                                <span className='font text-[14px] opacity-50 text-black dark:text-white/70'>{project.pendingTasksCount}</span> */}
                            </>
                        }
                    </div>
                    <div className='flex items-center justify-start gap-[10px]'>
                        <p className='font text-[14px] opacity-50 !font-normal text-black dark:text-white/70'>{project.completedTasksCount} / {project.pendingTasksCount + project.completedTasksCount} Tasks pending</p>
                    </div>
                    {!renameActive && <TasksStatusWidget taskStatus={{completed: project.completedTasksCount, total: project.pendingTasksCount + project.completedTasksCount}} className="focus-timer-widget absolute right-4 top-[50%] translate-y-[-50%]" showLabel={false} width={24} height={24} />}
                </NavLink>
                {
                    !renameActive &&
                    <div className='action-btn-wrapper bg-white dark:bg-black absolute rounded-20 flex items-center justify-center gap-[15px] py-2 px-[15px]  position right-[15px] top-[5px] d-none' style={{border: '1px solid rgba(0, 0, 0, 0.05)'}}>
                        <a href="#" className='flex items-center justify-center opacity-100' onClick={e => openDeleteProjectModal(e, project)}><Trash color="var(--theme-mode-color-white-reverse)" /></a>
                        <a href="#" className='flex items-center justify-center opacity-100' onClick={e => openEditProjectModal(e, project)}><EditIcon2 color="var(--theme-mode-color-white-reverse)" /></a>
                    </div>
                }
            </>
        </li>
    )
  })

  const SortableContainer = sortableContainer(() => {
    return (
        <ul className="ul-menus mt-5" css={{
            overflowY: 'auto'
        }}>
            {
                newProject &&
                <li className="li-menus border rounded-15 project-list-item">
                    <a className={`opacity-100 items-start justify-start flex-col relative active`}>
                        <div className='flex items-center justify-start gap-[10px] w-full flex-wrap'>
                            <FolderIcon width={18} height={18} color="black" fill="none" />
                            <RenameProjectModal project={showEditProjectModal} onHide={hideProjectModal} />
                        </div>
                    </a>
                </li>
            }
            {
                projectsListWithTasksCount.map((project, index) => {
                    return <SortableItem key={project.project_id} project={project} index={index} disabled={project.project_id === null} />
                })
            }
        </ul>
    )
  })

  const onSortEnd = async ({oldIndex, newIndex}) => {
    if(oldIndex == newIndex)
        return;

    const groupKeys = projectsListWithTasksCount.map(t => t.title);
    const newList = arrayMoveImmutable(groupKeys, oldIndex, newIndex);
    
    dispatch(setProjectsListWithTasksCount(newList.map(t => projectsListWithTasksCount.find(p => p.title == t))))

    try{
      await taskProjectPosition({ "positions": newList })
    }catch(e){
      console.log(e)  
    }
  }

  return (
    <>
        <div className='task-menus'>
            <ul className="ul-menus">
                <li className="li-menus" onClick={(e) => {
                    e.preventDefault()    
                }}>
                    <NavLink to='/tasks'
                    activeclass={activeHeaderLink == 'Upcoming' ? 'active' : 'inactive'} onClick={() => { setActiveHeaderLink('Upcoming') }} end
                    ><UpcomingTasksIcon color={activeHeaderLink == 'Upcoming' ? `var(--accent-color)` : `var(--theme-mode-color-white-reverse)`} fill={activeHeaderLink == 'Upcoming' ? `var(--accent-color)` : "none"}/> Upcoming <span className="mn-count" style={{ color: theme == "dark" ? "gray" : "" }}></span></NavLink>
                </li>

                <li className="li-menus" onClick={(e) => {
                    e.preventDefault()    
                }}>
                    <NavLink to="/tasks/overdue" activeclass={activeHeaderLink == 'Overdue' ? 'active' : 'inactive'} onClick={() => setActiveHeaderLink('Overdue')}><OverDueIcon color={activeHeaderLink == 'Overdue' ? `var(--accent-color)` : `var(--theme-mode-color-white-reverse)`}/> Overdue <span className="mn-count overdue-count" style={{ color: theme == "dark" ? "gray" : "" }}>{totalCount?.overdueCount ?? 0}</span></NavLink>
                </li>

                <li className="li-menus" onClick={(e) => {
                    e.preventDefault()    
                }}>
                    <NavLink to="/tasks/inbox" activeclass={activeHeaderLink == 'All' ? 'active' : 'inactive'} onClick={() => setActiveHeaderLink('All')}><InboxIcon color={activeHeaderLink == 'All' ? `var(--accent-color)` : `var(--theme-mode-color-white-reverse)`}/> Inbox <span className="mn-count inbox-count" style={{ color: theme == "dark" ? "gray" : "" }}>{totalCount?.totalCount ?? 0}</span></NavLink>
                </li>
                <li className="li-menus" onClick={(e) => {
                    e.preventDefault()    
                }}>
                    <NavLink to="/tasks/nodate" activeclass={activeHeaderLink == 'NoDate' ? 'active' : 'inactive'} onClick={() => setActiveHeaderLink('NoDate')}><NoDateIcon color={activeHeaderLink == 'NoDate' ? `var(--accent-color)` : `var(--theme-mode-color-white-reverse)`}/> No Date <span className="mn-count" style={{ color: theme == "dark" ? "gray" : "" }}>{totalCount?.noDateCount ?? 0}</span></NavLink>
                </li>
                <li className="li-menus" onClick={(e) => {
                    e.preventDefault()    
                }}>
                    <NavLink to="/tasks/complete" activeclass={activeHeaderLink == 'Completed' ? 'active' : 'inactive'} onClick={() => setActiveHeaderLink('Completed')}><CheckIcon color={activeHeaderLink == 'Completed' ? `var(--accent-color)` : `var(--theme-mode-color-white-reverse)`}/> Completed <span className="mn-count" style={{ color: theme == "dark" ? "gray" : "" }}></span></NavLink>
                </li>
                <li className="li-menus" onClick={(e) => {
                    e.preventDefault()    
                }}>
                    <NavLink to="/tasks/trash" activeclass={activeHeaderLink == 'Trash' ? 'active' : 'inactive'} onClick={() => setActiveHeaderLink('Trash')}><Trash color={activeHeaderLink == 'Trash' ? `var(--accent-color)` : `var(--theme-mode-color-white-reverse)`}/> Trash <span className="mn-count" style={{ color: theme == "dark" ? "gray" : "" }}></span></NavLink>
                </li> 
            </ul>
            <div className='hr-line mt-5 mb-5' css={{'&:after': {left: '0px !important'}}}></div>
            <div className='flex items-center justify-between w-full project-list-nav'>
                <h3 className=' font text-lg font-semibold opacity-50 accent-text-color'>Projects</h3>
                <ActionsDropdown actions={[{
                    icon: <FolderPlusIcon />,
                    title: 'Create New Project',
                    action: (e) => createNewProject(e)
                }]} />
            </div>
            <SortableContainer hideSortableGhost={true} useDragHandle={true} helperClass="sortable-helper" axis="y" lockAxis="y" onSortEnd={onSortEnd}></SortableContainer>
        </div>
        {showDeleteProjectModal && <DeleteProjectModal project={showDeleteProjectModal} theme={theme} onHide={hideProjectModal} />}
    </>
  )
}

export default SiteNav